import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import styles from './style.module.scss';
export const Loading = () => {
  return (
    <div className={styles.wrapper}>
      <CircularProgress color="secondary" />
    </div>
  );
};
